import { useState } from "react";
import { Skull, Ban } from "lucide-react";
import { Avatar } from "../ui";

export default function VoteScreen({ game, onVote, play }) {
  const [sel, setSel] = useState(null);
  const alive = game.players.filter((p) => p.alive);

  return (
    <div className="screen">
      <div className="round-head">
        <h1 className="screen-title">Votación</h1>
        <span className="badge" data-testid="vote-alive-count">{alive.length} vivos</span>
      </div>
      <p className="muted">Decidan en voz alta y toquen a quien quieren eliminar.</p>

      <div className="vote-grid" data-testid="vote-grid">
        {alive.map((p, i) => (
          <button key={p.name} className={`vote-card glass${sel === p.name ? " selected" : ""}`} onClick={() => { play("tap"); setSel(p.name); }} data-testid={`vote-player-${i}`}>
            <Avatar name={p.name} size="lg" />
            <span>{p.name}</span>
          </button>
        ))}
      </div>

      <div className="actions">
        <button className="btn btn-danger btn-xl full" disabled={!sel} onClick={() => onVote(sel)} data-testid="confirm-vote-btn">
          <Skull size={22} /> {sel ? `Eliminar a ${sel}` : "Elige a un jugador"}
        </button>
        <button className="btn btn-ghost full" onClick={() => onVote(null)} data-testid="skip-elimination-btn"><Ban size={18} /> Omitir eliminación</button>
      </div>
    </div>
  );
}
